import React, { useEffect, useState } from 'react';
import { Button, TextField } from '@mui/material';

import GenericDialog from '../GenericDialog';
import ContentBox from '../layout/ContentBox';
import { DigitalCase, PartialBy } from '../../redux/types';

export type Props = {
  display: boolean;
  onClose: () => void;
  onSubmit: (data: DigitalCaseEdit) => void;
  caseData?: DigitalCase; // dont use case data directly. Instead from the state
  digitalSectionId: number;
  digitalSurveyId: number;
}

export type DigitalCaseEdit = PartialBy<DigitalCase, 'id'>;
type CaseKeys = keyof DigitalCaseEdit;

const getEmptyCase = (digitalSectionId: number, digitalSurveyId: number): DigitalCaseEdit => ({
  name: '',
  url: '',
  digitalSectionId,
  digitalSurveyId,
  sortIndex: 0,
});

const DigitalCaseAddEditDialog: React.FC<Props> = ({
  display,
  onClose,
  onSubmit,
  caseData,
  digitalSectionId,
  digitalSurveyId,
}: Props) => {
  const [caseDataForm, setCaseDataForm] = useState<DigitalCaseEdit>(
    getEmptyCase(digitalSectionId, digitalSurveyId),
  );

  useEffect(() => {
    /** create new Digitalcase object for form for immutability */
    const controlledCaseData: DigitalCaseEdit = {
      name: caseData?.name || '',
      url: caseData?.url || '',
      id: caseData?.id,
      digitalSectionId,
      digitalSurveyId,
      sortIndex: caseData?.sortIndex || 0,
    };
    setCaseDataForm(controlledCaseData);
  }, [caseData, digitalSectionId, digitalSurveyId]);

  useEffect(() => {
    if (!display) {
      setCaseDataForm(getEmptyCase(digitalSectionId, digitalSurveyId));
    }
  }, [display, digitalSectionId, digitalSurveyId]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key: CaseKeys = event.target.id as CaseKeys;
    const val = event.target.value;
    const newState = {
      ...caseDataForm,
      [key]: val,
    } as DigitalCaseEdit;
    setCaseDataForm(newState);
  };

  return (
    <GenericDialog
      isOpen={display}
      onClose={onClose}
      closeButtonLabel="Close"
      maxWidth="sm"
      actions={[
        <Button
          key="confirmBtn"
          color="tertiary"
          variant="contained"
          onClick={() => { onSubmit(caseDataForm); }}
        >
          Confirm
        </Button>,
      ]}
    >
      <ContentBox title={caseDataForm?.id ? 'Edit Case' : 'Add Case'} elevation={0} color="tertiary">
        <form noValidate autoComplete="off">
          <TextField variant="standard" id="name" fullWidth label="Case Name" value={caseDataForm?.name} onChange={handleChange} />
          <TextField variant="standard" id="url" fullWidth label="Case URL" value={caseDataForm?.url} onChange={handleChange} />
        </form>
      </ContentBox>
    </GenericDialog>
  );
};

export default DigitalCaseAddEditDialog;
